<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <!-- breadcrumbs -->
            <fragment>
                <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            </fragment>
            <!-- //breadcrumbs -->
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <!-- //contents_head -->

            <!-- srchTop_wrap -->
            <div class="srchTop_wrap srchFaq_wrap">
                <article class="srch_basic">
                    <dl class="dl_search set_2" v-if="'C550' === corpCd || 'WA' === corpCd">
                        <dd class="clearable" data-input-type="input">
                            <input
                                type="text"
                                class="text_input w100p"
                                :placeholder="$t('FIELD.PLACEHOLDER.KNOWLEDGE.RESULTSEARCH')"
                                v-model="searchTitle"
                                @keyup.enter.stop="search(1)"
                                v-clearable
                            />
                        </dd>
                        <dd class="clearable" data-input-type="input">
                            <input
                                type="text"
                                class="text_input w100p"
                                :placeholder="$t('FIELD.GLOBAL.SEARCHKEYWORD')"
                                v-model="searchKeyword"
                                @keyup.enter.stop="search(1)"
                                v-clearable
                            />
                        </dd>
                        <dd class="btn">
                            <a href="javascript:" class="btn_srch" @click="search(1)">{{
                                $t('BUTTON.GLOBAL.SEARCH')
                            }}</a>
                        </dd>
                    </dl>
                    <dl class="dl_search" v-else>
                        <dd class="clearable" data-input-type="input">
                            <!-- <input
                                type="text"
                                class="text_input w100p"
                                :placeholder="$t('BUTTON.GLOBAL.SEARCH')"
                                v-model="searchTitle"
                                v-clearable
                            /> -->
                            <input
                                type="text"
                                class="text_input w100p"
                                placeholder="Enter keyword"
                                v-model="searchTitle"
                                @keyup.enter.stop="search(1)"
                                v-clearable
                            />
                        </dd>
                        <dd class="btn">
                            <a href="javascript:" class="btn_srch" @click="search(1)">{{
                                $t('BUTTON.GLOBAL.SEARCH')
                            }}</a>
                        </dd>
                    </dl>
                    <div class="top_mobile">
                        <div class="mobile_title">{{ $t('FIELD.GLOBAL.CATEGORY') }}</div>
                        <dl class="dl_select">
                            <dd data-input-type="select">
                                <select class="slt_white w100p" v-model="category1Code" @change="categoryList(2)">
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option
                                        v-for="item in category1CodeList"
                                        :value="item.code"
                                        :key="pageName + item.code"
                                    >
                                        {{ item.codeName }}
                                    </option>
                                </select>
                            </dd>
                        </dl>
                        <dl class="dl_select">
                            <dd data-input-type="select">
                                <select class="slt_white w100p" v-model="category2Code">
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option
                                        v-for="item in category2CodeList"
                                        :value="item.code"
                                        :key="pageName + item.code"
                                    >
                                        {{ item.codeName }}
                                    </option>
                                </select>
                            </dd>
                        </dl>
                    </div>
                </article>
                <article class="srch_detail">
                    <!-- mobile -->
                    <div class="list_wrap">
                        <header>
                            <h3>{{ $t('FIELD.FAQ.CATEGORY.QUICK') }}</h3>
                        </header>
                        <ul class="ul_list">
                            <li
                                v-for="item in supportSnb.faqQuickCategoryList"
                                :key="pageName + item.WORK_KEY_1 + item.WORK_KEY_2 + 'quick'"
                            >
                                <a href="javascript:" @click="getQuickCategoryClick(item.WORK_KEY_1, item.WORK_KEY_2)">
                                    {{ getQuickName(item.WORK_KEY_1_NM, item.WORK_KEY_2_NM, item.WORK_KEY_3_NM) }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </article>
                <a href="javascript:" class="btn_ico_srchBtm"><span class="sr_only"></span></a>
            </div>

            <!-- mobile_hide -->
            <div class="inquiry_wrap">
                <ul class="ul_list list_03">
                    <li
                        :class="getSnbClass(item.INQUIRY_TYPE1)"
                        v-for="(item, idx) in supportSnb.faqInquiry"
                        :key="pageName + item.INQUIRY_TYPE1 + idx + 'mobile'"
                    >
                        <a href="javascript:" @click="snbClick($event, item.INQUIRY_TYPE1, '', '')">
                            {{ item.INQUIRY_TYPE_NM1 }}<em v-if="item.TOTAL_CNT">({{ item.TOTAL_CNT }})</em>
                        </a>
                        <a
                            href="javascript:"
                            class="ico_arrow"
                            @click="snbClick($event, item.INQUIRY_TYPE1, '', 'arrow')"
                            v-if="!('ALL' === item.INQUIRY_TYPE1 || 'ETC' === item.INQUIRY_TYPE1)"
                        >
                            <span class="sr_only"></span>
                        </a>
                        <ul v-if="!('ALL' === item.INQUIRY_TYPE1 || 'ETC' === item.INQUIRY_TYPE1)">
                            <li
                                v-for="(itemSub, idxSub) in item.faqSubInquiry"
                                @click="snbClick($event, item.INQUIRY_TYPE1, itemSub.INQUIRY_TYPE2, '')"
                                :key="pageName + itemSub.INQUIRY_TYPE1 + idxSub + 'mobile'"
                            >
                                <a href="javascript:">
                                    {{ itemSub.INQUIRY_TYPE_NM2 }}
                                    <em v-if="itemSub.TOTAL_CNT">({{ itemSub.TOTAL_CNT }})</em>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <!-- //mobile_hide -->

            <!-- faq_wrap -->
            <div class="faq_wrap" v-if="0 < faqList.length">
                <ul class="faq_list">
                    <li
                        :class="item.GRADE === 'S' ? 'important' : ''"
                        v-for="(item, idx) in faqList"
                        :key="pageName + item.FAQ_ID + idx"
                    >
                        <div class="ico_faq_q" @click="faqClick($event, item.FAQ_ID)">
                            <em class="textcolor_important" v-if="'S' === item.GRADE">
                                [{{ $t('FIELD.GLOBAL.IMPORTANT') }}]
                            </em>
                            {{ item.TITLE }}
                        </div>
                        <div class="ico_faq_a">
                            <div class="q_cont">
                                <div class="namo_scrollbar" v-html="stripHtml(item.QUESTION_DESC)"></div>
                            </div>
                            <div class="a_cont">
                                <div class="namo_scrollbar" v-html="stripHtml(item.SOLUTION_DESC)"></div>
                                <span v-for="file in item.attach.rowData" :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN">
                                    <br />
                                    <a
                                        :href="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)"
                                        download="true"
                                        target="_blank"
                                        class="txt_link"
                                    >
                                        {{ file.FILE_NM }}
                                    </a>
                                </span>
                            </div>
                            <span v-if="'Y' === params.creationYn">
                                <br />
                                <div class="btn_wrap text_right pt-10">
                                    <a href="javascript:" class="txt_link" @click="register(item.FAQ_ID)">Modify</a>
                                </div>
                            </span>
                        </div>
                    </li>
                </ul>
                <div class="btn_wrap">
                    <a href="javascript:" class="btn_laodmore" @click="search(0)" v-if="currentRecords < totalRecords">
                        {{ $t('BUTTON.SEARCH.LOAD.MORE') }}
                        <em>
                            (<i>{{ currentRecords }}</i> / {{ totalRecords }})
                        </em>
                    </a>
                    <a
                        href="javascript:"
                        class="txt_link"
                        @click="register()"
                        v-if="(viewYn || (0 === totalRecords && !viewYn && searchYn)) && !getIsMobile"
                    >
                        {{ $t('MESSAGE.FAQ.CREATE') }}
                    </a>
                </div>
            </div>
            <div class="faq_wrap" v-else>
                <ul class="faq_list">
                    <li class="nodata">
                        <span>{{ $t('MESSAGE.GLOBAL.NO.DATA') }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import $ from 'jquery';
import store from '@/vuex/store';
import { SDLUtil, MenuUtil } from '@/utils';
import { mapActions, mapGetters } from 'vuex';
import { EventBus } from '@/utils/EventBus';
import api from '@/service';
import InnorixDownload from '~c/InnorixDownload';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

export default {
    name: 'viewFAQ',
    components: {
        'innorix-download': InnorixDownload,
        'skp-breadcrumbs': SKPBreadcrumbs,
    },
    data() {
        return {
            pageName: 'viewFAQ',
            pageTitle: '',
            currentPage: 1,
            totalRecords: 0,
            currentRecords: 0,
            nRecordsPerPage: Number(localStorage.getItem('listRows')),
            faqList: [],
            inquiry1Code: '',
            inquiry2Code: '',
            category1Code: '',
            category2Code: '',
            category1CodeList: [],
            category2CodeList: [],
            searchTitle: '',
            searchKeyword: '',
            attach: [],
            serviceType: 'common',
            viewYn: false,
            searchYn: false,
        };
    },
    mounted() {
        $('.btn_ico_srchBtm').on('click', function() {
            if ($('.srchTop_wrap').hasClass('extend') == true) {
                $('.srchTop_wrap').removeClass('extend');
            } else {
                $('.srchTop_wrap').addClass('extend');
            }
        });
        $('body').removeClass('overflow_hidden');

        this.categoryList(1);
        this.search(1);
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            loginSystem: 'getLoginSystem',
            corpCd: 'getCorpCd',
            supportSnb: 'getSupportSnb',
            supportSnbParams: 'getSupportSnbParams',
            menus: 'getMenus',
            params: 'getParams',
        }),
        getIsMobile() {
            return SDLUtil.isMobile() || '';
        },
    },
    watch: {
        supportSnbParams() {
            this.initializeSearch();
        },
    },
    methods: {
        ...mapActions(['setSupportSnbParams']),

        //function start
        //initialize start
        initializeSnbParams(faqInquiry1Code, faqInquiry2Code, faqCategory1Code, faqCategory2Code, type) {
            let saveSupportSnb = new Object();
            saveSupportSnb.faqInquiry1Code = SDLUtil.nvl(faqInquiry1Code);
            saveSupportSnb.faqInquiry2Code = SDLUtil.nvl(faqInquiry2Code);
            saveSupportSnb.faqCategory1Code = SDLUtil.nvl(faqCategory1Code);
            saveSupportSnb.faqCategory2Code = SDLUtil.nvl(faqCategory2Code);
            saveSupportSnb.faqType = SDLUtil.nvl(type);
            this.setSupportSnbParams(saveSupportSnb);
        },
        async initializeSearch() {
            if (SDLUtil.isNull(this.supportSnbParams.faqType)) {
                this.inquiry1Code = this.supportSnbParams.faqInquiry1Code;
                this.inquiry2Code = this.supportSnbParams.faqInquiry2Code;
                this.category1Code = this.supportSnbParams.faqCategory1Code;
                this.category2Code = this.supportSnbParams.faqCategory2Code;
                this.categoryList(1);
            } else if ('I' === this.supportSnbParams.faqType) {
                this.inquiry1Code = this.supportSnbParams.faqInquiry1Code;
                this.inquiry2Code = this.supportSnbParams.faqInquiry2Code;
            } else if ('C' === this.supportSnbParams.faqType) {
                this.category1Code = this.supportSnbParams.faqCategory1Code;
                this.category2Code = this.supportSnbParams.faqCategory2Code;
                this.categoryList(1);
            }

            this.search(1);
        },

        //initialize end
        //search option start
        search(page) {
            if (page === 0) {
                page = Number(this.currentPage) + 1;
            }
            this.currentPage = page;
            this.searchList();
        },

        async searchList() {
            let url = `${SDLUtil.API_URL}/basis/faq/faqSearch.skp`;
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    url,
                    qs.stringify({
                        page: this.currentPage,
                        nRecordsPerPage: this.nRecordsPerPage,
                        searchTitle: this.searchTitle,
                        searchKeyword: this.searchKeyword,
                        searchInquiryType1: this.inquiry1Code,
                        searchInquiryType2: this.inquiry2Code,
                        PRD_CATEGORY_CD1: this.category1Code,
                        PRD_CATEGORY_CD2: this.category2Code,
                        systemId: this.loginSystem,
                    }),
                )
                .then(resp => {
                    this.searchYn = true;
                    if (this.currentPage === 1) {
                        this.faqList = resp.data.list.rowData;
                    } else {
                        for (let list of resp.data.list.rowData) {
                            this.faqList.push(list);
                        }
                    }

                    this.currentPage = resp.data.search.PAGING_CURR_PAGE;
                    this.totalRecords = resp.data.search.totalRecords;
                    this.currentRecords =
                        Number(this.currentPage) * this.nRecordsPerPage > this.totalRecords
                            ? this.totalRecords
                            : Number(this.currentPage) * this.nRecordsPerPage;
                    SDLUtil.showLoadingBar(false);
                    EventBus.$emit('question-snb-status');
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        //search option end

        //search area start
        async categoryList(v) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 1) {
                codeCategoryId = 'ADM_CATEGORY_A';
                parentCode = '0';
                this.category1CodeList = [];
                this.category2CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.category1CodeList = resp;
                    this.categoryList(2);
                });
            } else if (v === 2) {
                codeCategoryId = 'ADM_CATEGORY_B';
                parentCode = this.category1Code;
                this.category2CodeList = [];
                let code = this.category2Code;
                await this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.category2CodeList = resp;
                    const idx = resp.findIndex(function(item) {
                        return item.code === code;
                    });
                    if (0 > idx) {
                        this.category2Code = '';
                    }
                });
            }
        },
        //search area end

        //page move start
        register(v) {
            if (SDLUtil.nvl(v)) {
                this.pageMove(this.pageName, { faq_id: SDLUtil.nvl(v) });
            } else {
                this.pageMove(this.pageName);
            }
        },
        pageMove(v, params) {
            if ('newQuestionList' === v || 'viewFAQ' === v || 'viewFAQNew' === v) {
                for (const menus of this.menus) {
                    for (const menu of menus.subMenu) {
                        let connUrl = menu.connUrl.replace('.skp', '');
                        if (SDLUtil.nvl(params)) {
                            if ('/basis/faq/faqForm' === connUrl) {
                                store.commit('PARAMS', { menuId: menu.menuId, creationYn: menu.creationYn });
                                return this.$router.push({ path: connUrl, query: params });
                            }
                        } else {
                            if ('/basis/qna/newQuestionList' === connUrl) {
                                store.commit('PARAMS', { menuId: menu.menuId, creationYn: menu.creationYn });
                                return this.$router.push('/basis/qna/createNewQuestion');
                            }
                        }
                    }
                }
            }

            return this.$router.push(MenuUtil.getSupportMain());
        },
        //page move end

        //etc start
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.corpCd);
            return codeResp;
        },
        faqClick(e, v) {
            this.viewYn = true;
            if (
                $(e.target)
                    .closest('li')
                    .hasClass('active') === true
            ) {
                $(e.target)
                    .closest('li')
                    .removeClass('active');
            } else {
                $('.faq_list li').removeClass('active');
                $(e.target)
                    .closest('li')
                    .addClass('active');
            }
        },
        getSnbClass(v) {
            let result = 'dir';
            let current = this.supportSnbParams.faqInquiry1Code;
            if ('ALL' === v) {
                result = 'active';
            } else {
                if (current === v) result += ' active';
            }
            return result;
        },
        snbClick(e, strA, strB, strC) {
            if ('ALL' === strA) strA = '';

            if (SDLUtil.isNull(strB)) {
                $('.list_03 > li > a').removeClass('active');
                $('.list_03 > li > .ico_arrow').removeClass('active');
                $(e.target).addClass('active');
            } else {
                $('.list_03 > li > ul > li > a').removeClass('active');
                $(e.target).addClass('active');
            }

            if ('arrow' === strC) return;

            this.initializeSnbParams(strA, strB, '', '', '');
        },
        getQuickCategoryClick(strC, strD) {
            let strA = this.supportSnbParams.faqInquiry1Code;
            let strB = this.supportSnbParams.faqInquiry2Code;
            this.initializeSnbParams(strA, strB, strC, strD, 'C');
        },
        getQuickName(strA, strB, strC) {
            let result = '';
            let ConnectionText = ' > ';
            if (!SDLUtil.isNull(strA)) {
                result += strA;
                if (!SDLUtil.isNull(strB)) {
                    result += ConnectionText + strB;
                    if (!SDLUtil.isNull(strC)) {
                        result += ConnectionText + strC;
                    }
                }
            }
            return result;
        },
        stripHtml(html) {
            var tmp = document.createElement('html');
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || '';
        },
        getDownloadUrl(SEQ, TOKEN) {
            let cmnApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;
            return cmnApiBase + '?attachFileSeq=' + SEQ + '&encToken=' + TOKEN;
        },
        //etc end
        //function end
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/faq/viewFAQ.vue